



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-payment-result-booking-card',
  components: {},
})
export default class PaymentResultBookingCard extends Vue {
  @Prop({ type: Boolean }) readonly success: boolean;
  @Prop({ type: String }) readonly title: string;
  @Prop({ type: String }) readonly subtitle: string;
}
